define.alias("ember-cli-string-helpers/helpers/lowercase", "settings/helpers/lowercase");